<div class="pos-reasons-container">
  <mat-accordion>
    <!-- Open Drawer Reasons -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Open Drawer Reasons</mat-panel-title>
        <mat-panel-description>Configure reasons shown when clerk opens the cash drawer</mat-panel-description>
      </mat-expansion-panel-header>
      <div class="reasons-grid">
        <mat-form-field *ngFor="let r of drawerReasons; let i = index" appearance="outline" class="reason-field">
          <mat-label>Reason {{ i + 1 }}</mat-label>
          <input matInput [(ngModel)]="drawerReasons[i]" placeholder="e.g. Cash float">
        </mat-form-field>
      </div>
    </mat-expansion-panel>

    <!-- Return Reasons -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Return Reasons</mat-panel-title>
        <mat-panel-description>Configure reasons shown when processing a product return</mat-panel-description>
      </mat-expansion-panel-header>
      <div class="reasons-grid">
        <mat-form-field *ngFor="let r of returnReasons; let i = index" appearance="outline" class="reason-field">
          <mat-label>Reason {{ i + 1 }}</mat-label>
          <input matInput [(ngModel)]="returnReasons[i]" placeholder="e.g. Defective">
        </mat-form-field>
      </div>
    </mat-expansion-panel>

    <!-- Price Change Reasons -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Price Change Reasons</mat-panel-title>
        <mat-panel-description>Configure reasons shown when clerk overrides a product price</mat-panel-description>
      </mat-expansion-panel-header>
      <div class="reasons-grid">
        <mat-form-field *ngFor="let r of priceChangeReasons; let i = index" appearance="outline" class="reason-field">
          <mat-label>Reason {{ i + 1 }}</mat-label>
          <input matInput [(ngModel)]="priceChangeReasons[i]" placeholder="e.g. Manager approval">
        </mat-form-field>
      </div>
    </mat-expansion-panel>

    <!-- Age Verification Override Reasons -->
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Age Verification Override Reasons</mat-panel-title>
        <mat-panel-description>Configure reasons shown when clerk overrides age verification at the POS</mat-panel-description>
      </mat-expansion-panel-header>
      <div class="reasons-grid">
        <mat-form-field *ngFor="let r of ageVerificationOverrideReasons; let i = index" appearance="outline" class="reason-field">
          <mat-label>Reason {{ i + 1 }}</mat-label>
          <input matInput [(ngModel)]="ageVerificationOverrideReasons[i]" placeholder="e.g. ID verified manually">
        </mat-form-field>
      </div>
    </mat-expansion-panel>
  </mat-accordion>

  <div class="save-row">
    <button mat-raised-button color="primary" (click)="save()" [disabled]="isSaving">
      <mat-icon>save</mat-icon>
      {{ isSaving ? 'Saving…' : 'Save POS Reasons' }}
    </button>
  </div>
</div>
